import React from 'react';
import { getOr } from 'lodash/fp';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { AppConfig, ClientGuid } from '../../helpers/config';

const awsS3BaseUrl = getOr(
  'https://s3.us-east-1.amazonaws.com/',
  'awsS3BaseUrl',
  AppConfig
);

const Image = styled.img`
  display: inline-block;
`;

const composeImageUrl = (bucket, image) =>
  `${awsS3BaseUrl.replace('//', `//${bucket}.`)}${ClientGuid}/${image}`;

const S3Image = ({ bucket, image, width, ...rest }) => (
  <Image
    width={width}
    {...rest}
    src={image ? composeImageUrl(bucket, image) : '/img/no-image.jpeg'}
  />
);

S3Image.propTypes = {
  bucket: PropTypes.string.isRequired,
  image: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

S3Image.defaultProps = {
  image: null,
  width: 250,
  height: 'auto'
};

export default S3Image;
